// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Image } from './image';
import { Manufacturer } from './manufacturer';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ManufacturerImage extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Int32 FK image */
  imageId!: number;
  /** Boolean */
  isPrimary!: boolean;
  /** Boolean */
  isThumbnail!: boolean;
  /** Int32 FK manufacturer */
  manufacturerId!: number;
  /** FK imageId */
  image!: Image;
  /** FK manufacturerId */
  manufacturer!: Manufacturer;
}

